import React, { useState, useRef, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import MaterialTable, { MTableToolbar } from 'material-table';
import Dialog from '@material-ui/core/Dialog';
import { localizationTable, options } from 'constants/table';

import Tooltip from "@material-ui/core/Tooltip";


import {
  CardContent,
  Grid,
  Button,
  Typography,
  TextField,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Paper
} from '@material-ui/core';

import { useStyles } from './styles';

import { ReportCompanyData } from 'services/dataService';
import { toast } from 'react-toastify';
import { Search, VerticalAlignBottom } from '@material-ui/icons';
import { statusUser } from 'constants/status';

export default ({ fields }) => {
  const [status, setStatus] = useState(1);
  const [attendance, setAttendance] = useState();
  const [name, setName] = useState('');
  const [disable, setDisable] = React.useState(false);
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const [disableButton, setDisableButton] = React.useState(true);
  const [anchorEl, setAnchorEl] = useState(null);

  const history = useHistory();



  const handleChange = (value) => {
    setStatus(value);
    handleFetch(value);
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { t } = useTranslation([
    'label',
    'toastify',
    'tables',
    'form',
    'button',
    'validation',
  ]);


  const columnsField = fields.map(field => ({
    ...field,
    sorting: false
  }));


  const { register, handleSubmit, control } = useForm();
  const tableRef = useRef();

  const classes = useStyles();

  const onSubmit = (data) => {
    setName(data.name);
    setAttendance(data.attendance)
    setStatus(data.status);

    setDisableButton(true);


    tableRef.current.state.query.page = 0;
    tableRef.current.onQueryChange();
  };

  const handleFetch = async (status) => {
    try {
      const response = await ReportCompanyData.getAttendanceReport({
        name,
        status,
        attendance,
        isExport: true,
      });
      return response.data;
    } catch (err) {
      toast.error(
        'Não foi possível buscar os dados do relatório, tente novamente mais tarde.'
      );
      return [];
    }
  };

  const handleFetchToXlsx = async (status, col) => {
    const response = await ReportCompanyData.getAttendanceToXlsx({
      name,
      status,
      attendance,
      isExport: true,
      columns: JSON.stringify(col),
    });

    return [];
  };

  const existeRelatorioParaBaixar = async () => {

    const res = localStorage.getItem("RelatorioPresencialDownload");

    if (res == "1") {
      setDisable(true);
    }
  };


  const customExport = useCallback(async (type) => {
    try {
      setDisable(true);

      localStorage.setItem("RelatorioPresencialDownload", "1");

      toast.info(t('toastify:commons.toast_generatereport'));
      const filteredColumns = tableRef.current.props.columns.map(column => {
        const { tableData, ...rest } = column;
        return rest;
      });
      const responseData = handleFetchToXlsx(status, filteredColumns);

      setShowConfirmation(true);

    } finally {
      handleClose();
    }
  }, [status]);

  const handleClickConfirmSave = () => {
    setShowConfirmation(false);
    window.location.reload()
  };

  const handleNotificationClick = () => {
    history.push('/notification');
  };

  return (
    <>
      <div className='notranslate'>
      <Dialog
          open={showConfirmation}
          onClose={() => setShowConfirmation(false)}
        >
          <DialogTitle style={{ fontSize: '22px', textAlign: 'center' }}>⚠️ Atenção</DialogTitle>
          <DialogContent style={{ textAlign: 'center' }}>
            <Typography variant="subtitle1" gutterBottom>
              Em alguns instantes o seu Relatório Presencial estará disponível em Notificações.
            </Typography>
            <Typography variant="subtitle1">
              Basta clicar em <b>Notificações</b> &rarr; <b>Ver todas</b>
            </Typography>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClickConfirmSave()}
              style={{ padding: '10px 50px' }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <MaterialTable
          title={`${t('tables:reports.title_reports_attendance')}`}
          tableRef={tableRef}
          columns={
            columnsField ||
            [
              {
                title: `${t('tables:reports.attendance.name_column')}`,
                field: `name_column`,
                render: (rowData) => rowData.name_column
              },
              {
                title: `${t('tables:reports.attendance.cpf')}`,
                field: `cpf`,
                render: (rowData) => rowData.cpf
              },
              {
                title: `${t('tables:reports.attendance.email_column')}`,
                field: `email_column`,
                render: (rowData) => rowData.email_column
              },
              {
                title: `${t('tables:reports.attendance.quantity_courses')}`,
                field: 'quantity_courses',
                render: (rowData) => rowData.quantity_courses
              },
              {
                title: `${t('tables:reports.attendance.workload')}`,
                field: 'workload',
                render: (rowData) => rowData.workload
              },
              {
                title: `${t('tables:reports.attendance.created_at')}`,
                field: 'created_at',
                render: (rowData) => rowData.created_at
              },
              {
                title: `${t('tables:reports.attendance.start_at')}`,
                field: 'start_at',
                render: (rowData) => rowData.start_at
              },
              {
                title: `${t('tables:reports.attendance.finished_at')}`,
                field: 'finished_at',
                render: (rowData) => rowData.finished_at
              },
              {
                title: `${t('tables:reports.attendance.instructor')}`,
                field: 'instrutctor',
                render: (rowData) => rowData.instrutctor
              }
            ]
          }
          data={async (query) => {
            try {
              const response = await ReportCompanyData.getAttendanceReport({
                page: query.page + 1,
                limit: query.pageSize,
                name,
                status,
                attendance
              });

              existeRelatorioParaBaixar();


              let { report, currentPage, totalCount } = response.data;

              report = report?.map((attendance) => {
                let customFields = {};

                if (attendance?.custom_field_values) {
                  const formattedCustomFieldValue = JSON.parse(
                    attendance?.custom_field_values
                  );

                  for (const field of formattedCustomFieldValue) {
                    customFields[field?.fieldName] = field?.fieldValue;
                  }
                }

                return { ...attendance, ...customFields };
              });

              return {
                data: report,
                page: currentPage - 1,
                totalCount: totalCount,
              };

            } catch (err) {
              toast.error(t('toastify:commons.toast_error_api'));
              return { data: [] };
            }
          }}
          components={{
            search: true,
            title: true,
            Toolbar: (props) => (
              <div>
                <MTableToolbar {...props} />
                <form onSubmit={handleSubmit(onSubmit)}>
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid item md={4} xs={12}>
                        <TextField
                          fullWidth
                          label={t('form:User.input_first_name')}
                          name="name"
                          type="text"
                          variant="outlined"
                          defaultValue={name || ''}
                          inputRef={register}
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <TextField
                          fullWidth
                          label={t('form:Trail.input_name_attendance')}
                          name="attendance"
                          type="text"
                          variant="outlined"
                          defaultValue={attendance || ''}
                          inputRef={register}
                        />
                      </Grid>
                      <Grid item md={2} xs={12}>
                        <FormControl style={{ minWidth: 130 }}>
                          <InputLabel id="status">
                            {t("form:commons.input_status")}
                          </InputLabel>
                          <Controller
                            as={
                              <Select>
                                <MenuItem value={1}>{t(statusUser[1]?.title)}</MenuItem>
                                <MenuItem value={2}>{t(statusUser[4]?.title)}</MenuItem>
                              </Select>
                            }
                            name="status"
                            control={control}
                            onChange={([event]) => handleChange(event.target.value)}
                            defaultValue={status}
                            value={status}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item md={2} xs={12} className={classes.actions}>
                        <Button
                          color="primary"
                          variant="contained"
                          size="large"
                          type="submit"
                        >
                          <Search />
                          {t('button:User_solictation.btn_advanced_filter')}
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </form>
              </div>
            ),
          }}
          localization={localizationTable(t)}
          actions={[
            {
              icon: () => (
                disableButton && (
                  <>
                    <Tooltip title={"Somente após o download de um relatório solicitado, é possível solicitar novamente."}>
                      <span>
                        <Button disabled={disable}>
                          <VerticalAlignBottom
                            handleFetch={() => handleFetch(status)}
                            onClick={() => customExport("excel")}
                            tableRef={tableRef}
                          />
                        </Button>
                      </span>
                    </Tooltip>
                  </>
                )
              ),
              isFreeAction: true,
            },
          ]}
          options={{
            ...options,
            exportButton: false,
          }}
        />
      </div>

    </>
  );
};
